import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import useCollectionServices from 'hooks/useCollectionServices';
import services from 'services';
import { ApplicationModuleProps } from 'types';
import { calcAvailableModules, calcRoutedModules, isAppModule } from 'utils';
import MobileNavigationButton from 'view/components/MobileNavigation/MobileNavigationButton';

import { NavigationResult } from './useSidebarNavigation';

export interface MobileNavigationResult extends NavigationResult {
  open: boolean;
}

const useMobileNavigation = () => {
  if (!services.getWidget('AppFrame:MobileNavigationButton')) {
    services.registerWidget({
      name: 'AppFrame:MobileNavigationButton',
      ...singleSpaReact<ApplicationModuleProps>({
        React,
        ReactDOM,
        rootComponent: MobileNavigationButton,
        errorBoundary: (err, errInfo, props) => props?.services?.appFrame.error.handleErrorBoundary(React, err),
      }),
    });
  }

  const [open, setOpen] = useState(services.appFrame.mobileNavigation.isOpen);
  useEffect(() => {
    return services.appFrame.mobileNavigation.onOpenChange(setOpen);
  }, []);
  useEffect(() => {
    services.executeAction('appFrame:onMobileNavigationChange', open);
  }, [open]);

  const applications = useCollectionServices(services.appFrame.mobileNavigation.applications);
  const partialCtx = useMemo(() => {
    const modules = calcAvailableModules(applications).filter(isAppModule);
    const routedModules = calcRoutedModules(modules);
    const appModules = modules.filter((module) => !module.hidden);
    const defaultModule = modules.find((module) => isAppModule(module) && module.default) || routedModules[0] || null;
    return {
      routedModules,
      appModules,
      defaultModule,
    };
  }, [applications]);

  return useMemo(
    () => ({
      ...partialCtx,
      open,
    }),
    [partialCtx, open],
  );
};

export default useMobileNavigation;
